import type { Dict } from '../utils'

import { createContext } from '../utils'

const [BreadcrumbsProvider, useBreadcrumbsContext] = createContext<Dict>({ isOptional: true })

export { BreadcrumbsProvider, useBreadcrumbsContext }
